
$(document).ready(function() {
    if(!document.querySelector('.solar-wrap')) return false;
    
    var device = "pc";
    var mobileArr = new Array("iphone", "ipod", "android", "windows ce", "blackberry", "symbian", "windows phone", "webos", "opera mini", "opera mobi", "polaris","iemobile", "lgtelecom", "nokia", "sonyericsson", "samsung");

    //디바이스 체크
    for(var txt in mobileArr){
         if(navigator.userAgent.toLowerCase().match(mobileArr[txt]) != null){
            console.log(navigator.userAgent.match(mobileArr[txt]));
            device = "mobile"
            break;
         }
    }
    
    var solar = {
        $el : $(document).find('.solar-wrap'),
        $pgWrap : $(document).find('.pagination-wrap'),
        $pgUl : $(document).find('.pagination-wrap .pagination ul'),
        $pgCategory : $(document).find('.category-item'),
        url : $(document).find('.item-wrap').data('url'),
        totalNum : 0,
        currentIdx : 1,
        clickElVal : 1,
		clickElIdx : 0,
		init : function() {
			$('.result-area').hide();
            var param = "";
            $('.item-list').empty();
            (!solar.$el.hasClass('cnm'))? solar.drawingList(solar.url, param):''; //BTOBGLOBAL-444 
            solar.event();
            solar.$el.find('.privacy').find('.privacy-eu').hide(); // BTOBGLOBAL-471 : 20210531 add
        },
        event : function(){
            // radio
            // change event 이전 기본 url과 submit 함수는 세팅 되어야 합니다.
            solar.$el.find('input[name="radio-1"]').on('change', function(){
                var $this = $(this);
                 var $thisCheck = $this.prop('checked');
                if ( $this && $this.is('#NonEU') ) {
                     solar.$el.find('.privacy1 .link-text').attr('href', $('#ppNonEuUrl').val());
                     solar.$el.find('.privacy2 .link-text').attr('href', $('#dmNonEuUrl').val());
                     solar.$el.find('.privacy3 .link-text').attr('href', $('#toNonEuUrl').val());
                     var nonEuUrl = $(document).find('.solar-wrap').find('#nonEuUrl').val();
                     solar.$el.find('#solarBlogForm').attr('action', nonEuUrl);
                     var nonEuTransferLabel = solar.$el.find('#nonEuTransferLabel').val(); // BTOBGLOBAL-222
                     solar.$el.find('.solarTransferLabel').text(nonEuTransferLabel); // BTOBGLOBAL-222
                     solar.$el.find('.btn-subscribe').off('click').on('click',function(){
                         // submit none eu
                    });
                }
                if ( $this && $this.is('#EU') ) {
                    solar.$el.find('.privacy1 .link-text').attr('href', $('#ppEuUrl').val());
                    solar.$el.find('.privacy2 .link-text').attr('href', $('#dmEuUrl').val());
                    solar.$el.find('.privacy3 .link-text').attr('href', $('#toEuUrl').val());
                    var euUrl = $(document).find('.solar-wrap').find('#euUrl').val();
                    solar.$el.find('#solarBlogForm').attr('action', euUrl);
                    var euTransferLabel = solar.$el.find('#euTransferLabel').val(); // BTOBGLOBAL-222
                    solar.$el.find('.solarTransferLabel').text(euTransferLabel); // BTOBGLOBAL-222
                    solar.$el.find('.btn-subscribe').off('click').on('click',function(){
                        // submit eu
                    });
                }
            });
            // toggle
            solar.$el.find('.category-btn').on('click',function(e){
                var $this = $(this);
                $this.toggleClass('active');
                var $category = solar.$el.find('.toggle-category-list');
                $category.toggleClass('active').slideToggle();
                if( $category.is('.active') ){
                    $this.attr('aria-expanded', true);
                } else {
                    $this.attr('aria-expanded', false);
                }
            });
            // fixed
            $(window).on('scroll',function(){
                var $fixedEl = solar.$el.find('.category-area-right');
                var $itemWrap = solar.$el.find('.item-wrap');
		/* BTOBGLOBAL-444 s*/
		 if(!$fixedEl.length){
                	return false;
                }
		/* BTOBGLOBAL-444 e*/
                var elTop = $itemWrap.offset().top;
                var winTop = $(this).scrollTop();
                var maxHeight = $fixedEl.offset().top + $fixedEl.height() + 50;
                var footTop = $('.footer-box:first').offset().top;
                if ( winTop >= elTop ) {
                    if( ! $fixedEl.is('.fixed') ) $fixedEl.addClass('fixed');
                } else {
                    $fixedEl.removeClass('fixed');
                }
                if( maxHeight >= footTop ){
                    $fixedEl.addClass('invisible');
                } else {
                    $fixedEl.removeClass('invisible');
                }
            });
            solar.$el.find('.column-foot.expander > .link-text').on('click',function(e){
            	var page = solar.currentIdx + 1;
            	solar.currentIdx = page;
            	var categoryName = $(document).find('#categoryNameField').text();
            	var param = {'page' : page, 'categoryName' : categoryName};
                (!solar.$el.hasClass('cnm'))? solar.drawingList(solar.url, param):''; //BTOBGLOBAL-444
            });
            solar.$pgCategory.on('click', function(e){
            	solar.clickElIdx = 0;
				solar.clickElVal = 1;
                solar.currentIdx = 1;
                
                solar.$el.find('.category-list').find('li a.active').removeClass("active")
	            var selectItem = $("a.category-item:contains('"+$(this).text()+"')")
                selectItem.addClass('active')

            	var parentLi = $(this).closest('li');
            	var categoryCount = $(parentLi).find('.category-num').text();
            	var param = {'categoryName' : $(this).text(), 'categoryCount' : categoryCount};
            	$('.item-list').empty();
               	(!solar.$el.hasClass('cnm'))? solar.drawingList(solar.url, param):''; //BTOBGLOBAL-444
            });
            solar.$el.find('#checkbox_4').on('change', function(e){
            	if($('input:checkbox[id="checkbox_4"]').is(":checked")){
            		$('input:checkbox[id="checkbox_1"]').prop("checked", true);
            		$('input:checkbox[id="checkbox_2"]').prop("checked", true);
            		$('input:checkbox[id="checkbox_3"]').prop("checked", true);
            	}else{
            		$('input:checkbox[id="checkbox_1"]').prop("checked", false);
            		$('input:checkbox[id="checkbox_2"]').prop("checked", false);
            		$('input:checkbox[id="checkbox_3"]').prop("checked", false);
            	}
            });
            $('#solarBlogForm').submit(function(e){
            	e.preventDefault();
            	var url = $('#solarBlogForm').attr('action');
            	//var region = $("input:radio[name='radio-1']:checked").attr('id');
            	var region = $("#selectRegion").val();
            	var firstName = $('#firstName').val();
            	var lastName = $('#lastName').val();
            	var email = $('#email').val();
            	var check1 = $('input:checkbox[id="checkbox_1"]').is(":checked");
            	var check2 = $('input:checkbox[id="checkbox_2"]').is(":checked");
            	var check3 = $('input:checkbox[id="checkbox_3"]').is(":checked");
            	// BTOBGLOBAL-355 start
            	var elqFormName = $('#elqFormName').val();
            	var elqSiteID = $('#elqSiteID').val();
            	var elqSiteID = $('#elqSiteID').val();
            	var param = {
            			region : region,
            			lastName : lastName,
            			firstName : firstName,
            			email : email,
            			dm_agreement : check1,
            			pp_subscription : check2,
            			transferoutsideeea : check3,
            			elqFormName : elqFormName,
            			elqSiteID : elqSiteID
            	};
            	// BTOBGLOBAL-355 end
            	
            	if($('#solarBlogForm').checkValidation()){
	            	ajax.call(url, param, 'jsonp', function(data){
	            		$('.input-area').hide();
	            		if(device == 'pc'){
	            			$('.result-area').show();
	            		}
	            	});
            	}
            });
            /* BTOBGLOBAL-471 : 20210531 add */
            solar.$el.find('select[name="selectRegion"]').on('change', function(){
            	if($(this).val() == 'eu'||$(this).val() == 'Europe'){
            		solar.$el.find('.privacy').find('.privacy-non-eu').hide();
            		solar.$el.find('.privacy').find('.privacy-eu').show();
            		solar.$el.find('.privacy3 .error-msg .required').text(solar.$el.find('.privacy3 #privacyEuErrorMsg').val());
            	}else{
            		solar.$el.find('.privacy').find('.privacy-non-eu').show();
            		solar.$el.find('.privacy').find('.privacy-eu').hide();
            		solar.$el.find('.privacy3 .error-msg .required').text(solar.$el.find('.privacy3 #privacyNonEuErrorMsg').val());
            	}
            });
            /*// BTOBGLOBAL-471 : 20210531 add */
        },
        // drawingList
        drawingList: function(url, param){
            var ctgName = param.categoryName;
            var ctgCount = param.categoryCount;
            if(param != '' && typeof ctgName != 'undefined' && typeof ctgCount != 'undefined'){
                document.getElementById("categoryNameField").innerHTML = param.categoryName;
                document.getElementById("categoryNumField").innerHTML = param.categoryCount;
            }
            if(ctgName == 'All Categories'){
                param.categoryName = '';
            }
			ajax.call(url, param, 'json', function(data){
                solar.totalNum = data.data[0].totalSize;
                data = data.data[0].articleList;
                var HTML =  $();
                for(var i=0;i<data.length;i++){
                    HTML = HTML.add( 
                        '<li class="item">'
                        +'<a href="'+(data[i].articlePagePath)+'" class="anchor">'
                        +'<span class="thumbnail"><img src="'+(data[i].articleImgPath)+'" aria-hidden="true" alt="'+(data[i].articleName)+'"></span>'
                        +'<div class="summary"><strong class="subject">'+(data[i].articleName)+'</strong><p class="date">'+(data[i].publishDate)+'</p></div>'
                        +'</a>'
                        +'</li>'
                    );
                }
                $('.item-list').append(HTML);
                if( solar.totalNum <= $('.item-list > li').length ) {
                    solar.$el.find('.column-foot.expander').addClass('hide');
                } else {
                    solar.$el.find('.column-foot.expander').removeClass('hide');
                }
			}, 'post', 'body');
        }
    }
    solar.init();
});